import React from 'react';
import { routeStatusClasses } from "../common/tailwindClassnames";
import { HealthyStatusIcon, UnhealthyStatusIcon, DisabledStatusIcon, NeedsReviewStatusIcon } from "../common/ProjectIcons";

export const getRouteStatus = (status: string, details_page: boolean, t: (key: string) => string) => {
    switch (status) {
        case "healthy":
            return { text: t("Healthy"), style: routeStatusClasses.healthy(details_page), icon: <HealthyStatusIcon /> };
        case "unhealthy":
            return { text: t("Unhealthy"), style: routeStatusClasses.unhealthy(details_page), icon: <UnhealthyStatusIcon /> };
        case "needs_review":
            return { text: t("Needs Review"), style: routeStatusClasses.needsReview(details_page), icon: <NeedsReviewStatusIcon /> };
        case "disabled":
            return { text: t("Disabled"), style: routeStatusClasses.disabled(details_page), icon: <DisabledStatusIcon /> };
        default:
            return { text: t("Unknown"), style: routeStatusClasses.unknown(details_page), icon: <NeedsReviewStatusIcon /> };
    }
};